// privatokonomi-messages-part3 translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'pkn.tw.step.situation': 'Tu situación',
  'pkn.tw.step.income': 'Ingresos',
  'pkn.tw.step.workTravel': 'Trabajo y viajes',
  'pkn.tw.step.housingDebt': 'Vivienda y deuda',
  'pkn.tw.step.family': 'Familia',
  'pkn.tw.step.savingsInvesting': 'Ahorro e inversión',
  'pkn.tw.step.otherMatters': 'Otras circunstancias',
  'pkn.tw.step.business': 'Actividad empresarial',
  'pkn.tw.step.deductions': 'Deducciones',
  'pkn.tw.step.summary': 'Resumen',
  'pkn.acc.fillName': 'Introduce un nombre de cuenta',
  'pkn.acc.editAccount': 'Editar cuenta',
  'pkn.acc.addAccount': 'Añadir cuenta',
  'pkn.acc.fieldName': 'Nombre de la cuenta',
  'pkn.acc.phName': 'P. ej. cuenta corriente de DNB',
  'pkn.acc.fieldNumber': 'Número de cuenta',
  'pkn.acc.phNumber': 'P. ej. 1234.56.78901',
  'pkn.acc.openingBalance': 'Saldo inicial (kr)',
  'pkn.acc.closingBalance': 'Saldo final (kr)',
  'pkn.acc.numberHint': 'El número de cuenta facilita asociar los futuros extractos a la cuenta correcta. Usa el signo menos para la deuda de crédito, p. ej. −12400.',
  'pkn.acc.account': 'Cuenta',
  'pkn.acc.accountLower': 'cuenta',
  'pkn.acc.theAccount': 'la cuenta',
  'pkn.acc.theStatement': 'el extracto',
  'pkn.acc.noNumber': 'Sin número de cuenta',
  'pkn.acc.noBalance': 'Sin saldo',
  'pkn.acc.transactionsCount': '{count} transacciones',
  'pkn.acc.statementOne': '{count} extracto',
  'pkn.acc.statementMany': '{count} extractos',
  'pkn.acc.kpi.read': 'Transacciones leídas',
  'pkn.acc.kpi.statements': 'Extractos',
  'pkn.acc.kpi.categories': 'Categorías',
  'pkn.acc.kpi.unprocessed': 'Sin procesar',
  'pkn.acc.statementsFor': 'Extractos de {year} importados en {name}',
  'pkn.acc.noStatementsForYear': 'No hay extractos de {year} vinculados a esta cuenta. Elige otro año o sube un archivo en «Importar datos financieros».',
  'pkn.acc.statement': 'Extracto bancario',
  'pkn.acc.uploaded': 'Subido',
  'pkn.acc.readIn': 'Leído',
  'pkn.acc.failed': 'Error',
  'pkn.acc.reading': 'Leyendo …',
  'pkn.acc.deleteTitle': '¿Eliminar {name}?',
  'pkn.acc.deleteAccount': 'Eliminar cuenta',
  'pkn.acc.deleteWith': 'La cuenta se elimina junto con',
  'pkn.acc.and': 'y',
  'pkn.acc.linkedCannotUndo': 'vinculados a ella. Esta acción no se puede deshacer.',
  'pkn.acc.deletePermanent': 'La cuenta se elimina de forma permanente. Esta acción no se puede deshacer.',
  'pkn.acc.deleting': 'Se eliminará',
  'pkn.acc.deletingSuffix': 'y todas las transacciones leídas de él. Esta acción no se puede deshacer.',
  'pkn.acc.noAccounts': 'Todavía no hay cuentas registradas. Pulsa «Añadir cuenta» para registrar una cuenta corriente, una cuenta de ahorro o una tarjeta de crédito, o elige un nombre de cuenta al subir un extracto.',
  'pkn.acc.noAccountsOfType': 'No hay cuentas de este tipo.',
  'pkn.acc.cardStatementOne': '{count} extracto',
  'pkn.acc.cardStatementMany': '{count} extractos',
  'pkn.imp.beingRead': 'Leyéndose …',
  'pkn.imp.pickAccountFor': 'Elige a qué cuenta pertenece el extracto.',
  'pkn.imp.numberHint': 'El número de cuenta facilita asociar los futuros extractos y la integración bancaria a la cuenta correcta.',
  'pkn.imp.accounts': 'Cuentas',
  'pkn.imp.statements': 'Extractos bancarios',
  'pkn.imp.sayA': 'Sube un extracto bancario y',
  'pkn.imp.sayB': 'leerá cada transacción, la vinculará a la cuenta correcta y la categorizará automáticamente. No tienes que hacer nada manualmente: mantengo tus finanzas al día en segundo plano.',
  'pkn.imp.recategorising': 'Categorizando …',
  'pkn.imp.recategorise': 'Volver a categorizar',
  'pkn.imp.uploadingDots': 'Subiendo …',
  'pkn.imp.dropHere': 'Arrastra y suelta archivos aquí',
  'pkn.imp.dropSub': 'Extractos bancarios, extractos de tarjeta de crédito y exportaciones CSV. Elegirás la cuenta en el siguiente paso. XLSX y CSV se leen directamente; el PDF se lee en la medida de lo posible a partir del texto.',
  'pkn.imp.uploading': 'Subiendo',
  'pkn.imp.chooseFiles': 'Elegir archivos',
  'pkn.imp.fetching': 'Obteniendo el estado de la importación …',
  'pkn.imp.unlinkedNote': 'Estos extractos no tienen cuenta. Vincúlalos a una cuenta para incluirlos en el resumen.',
  'pkn.imp.upload': 'Subir',
  'pkn.kat.sort.date-desc': 'Más recientes primero',
  'pkn.kat.sort.date-asc': 'Más antiguos primero',
  'pkn.kat.sort.amt-desc': 'Importe más alto',
  'pkn.kat.sort.amt-asc': 'Importe más bajo',
  'pkn.kat.tips.housing.1': 'Cambia el contrato de electricidad: el precio de mercado puede ser más barato que el precio fijo',
  'pkn.kat.tips.housing.2': 'Revisa las suscripciones de TV y banda ancha que no aprovechas del todo',
  'pkn.kat.tips.housing.3': 'Comprueba si se puede negociar a la baja el tipo de interés de la hipoteca',
  'pkn.kat.tips.food.1': 'Compra con una lista semanal: las compras por impulso suponen una parte importante',
  'pkn.kat.tips.food.2': 'Cambia a las marcas propias de los supermercados en lo que compras con frecuencia',
  'pkn.kat.tips.food.3': 'Haz la compra grande con menos frecuencia para desperdiciar menos y comprar menos por impulso',
  'pkn.kat.tips.shopping.1': 'Añade los artículos al carrito y espera 48 horas antes de comprar',
  'pkn.kat.tips.shopping.2': 'Fija un presupuesto mensual de compras',
  'pkn.kat.tips.shopping.3': 'Date de baja de boletines y notificaciones de apps que te tientan a comprar',
  'pkn.kat.tips.transport.1': 'Valora un abono mensual en lugar de billetes sencillos',
  'pkn.kat.tips.transport.2': 'Ve en bicicleta o a pie los trayectos cortos que hoy haces en coche',
  'pkn.kat.tips.transport.3': 'Reposta en la gasolinera más barata de tu zona',
  'pkn.kat.tips.dining.1': 'Fija un límite semanal para salir a comer y beber',
  'pkn.kat.tips.dining.2': 'Cambia dos noches de comida para llevar a la semana por comida casera',
  'pkn.kat.tips.dining.3': 'Pide para recoger en lugar de a domicilio: ahorras comisiones y propinas',
  'pkn.kat.tips.travel.1': 'Reserva los vuelos entre 6 y 8 semanas antes de la salida para conseguir un mejor precio',
  'pkn.kat.tips.travel.2': 'Viaja fuera de las vacaciones escolares cuando sea posible',
  'pkn.kat.tips.travel.3': 'Usa los puntos de bonificación que ya has acumulado',
  'pkn.kat.tips.insurance.1': 'Reúne tus seguros en un solo proveedor para obtener un descuento conjunto',
  'pkn.kat.tips.insurance.2': 'Comprueba que la cobertura se ajusta realmente a tus necesidades',
  'pkn.kat.tips.insurance.3': 'Aumenta un poco la franquicia para pagar una prima mensual menor',
  'pkn.kat.tips.subscriptions.1': 'Cancela los servicios que no has usado en los últimos 30 días',
  'pkn.kat.tips.subscriptions.2': 'Comparte una suscripción familiar de streaming en lugar de tener la tuya',
  'pkn.kat.tips.subscriptions.3': 'Cambia al pago anual donde sea más barato que el mensual',
  'pkn.kat.tips.default.1': 'Fija un tope mensual para la categoría',
  'pkn.kat.tips.default.2': 'Revisa los cargos fijos que puedes ajustar o cancelar',
  'pkn.kat.tips.default.3': 'Traslada lo que ahorras directamente a un objetivo de ahorro',
  'pkn.kat.importedStatement': 'Extracto bancario importado',
  'pkn.kat.unknown': 'Desconocido',
  'pkn.kat.leadEmpty': 'Todavía no hay transacciones importadas en {category} para este periodo.',
  'pkn.kat.leadOne': '{category} suma {total} repartidos en {count} transacción, con una media de {average} por compra.',
  'pkn.kat.leadMany': '{category} suma {total} repartidos en {count} transacciones, con una media de {average} por compra.',
  'pkn.kat.topItem': 'La partida individual más grande es {name}, donde has gastado {amount}.',
  'pkn.kat.changeUp': 'La categoría aumentó un {pct} % respecto al mes anterior.',
  'pkn.kat.changeDown': 'La categoría bajó un {pct} % respecto al mes anterior.',
  'pkn.kat.lineOne': '{count} línea',
  'pkn.kat.lineMany': '{count} líneas',
  'pkn.kat.moving': 'Moviendo …',
  'pkn.kat.move': 'Mover',
  'pkn.kat.vsPrev': 'frente al mes anterior',
  'pkn.kat.timesAverage': '{factor}× la media',
  'pkn.kat.howToCut': 'Cómo puedes recortar',
  'pkn.kat.potential': 'Potencial ~{amount}/mes',
  'pkn.kat.clearAll': 'Quitar todo',
  'pkn.kat.selectAll': 'Seleccionar todo',
  'pkn.kat.learn': 'Aprender de esta elección para futuras importaciones',
  'pkn.kat.noTxInCategory': 'No hay transacciones en esta categoría.',
  'pkn.kat.noTxMatchSearch': 'Ninguna transacción coincide con la búsqueda.',
  'pkn.sce.notCalculable': 'No calculable',
  'pkn.sce.base.label': 'Plan actual',
  'pkn.sce.base.story': 'Con el plan actual (con {save} de ahorro y {debt} de amortización extra de deuda cada mes), este es el rumbo que llevan tus finanzas. Todos los escenarios de abajo se calculan a partir de este punto de partida.',
  'pkn.sce.saving.label': 'Aumentar el ahorro',
  'pkn.sce.saving.field': 'Ahorro extra al mes',
  'pkn.sce.saving.statExtra': 'Ahorro extra',
  'pkn.sce.saving.stat5y': 'En 5 años',
  'pkn.sce.saving.story': 'Si apartas {amount} extra al mes, tu patrimonio crece notablemente más rápido. Los objetivos se alcanzan, de media, varios meses antes.',
  'pkn.sce.home.label': 'Comprar una vivienda',
  'pkn.sce.home.price': 'Precio de la vivienda',
  'pkn.sce.equity': 'Capital propio',
  'pkn.sce.rate': 'Interés',
  'pkn.sce.term': 'Plazo del préstamo',
  'pkn.sce.loanType': 'Tipo de préstamo',
  'pkn.sce.annuity': 'Cuota fija',
  'pkn.sce.serial': 'Amortización constante',
  'pkn.sce.loan': 'Préstamo',
  'pkn.sce.instalment': 'Cuota',
  'pkn.sce.home.firstInterest': 'Interés inicial',
  'pkn.sce.home.value': 'Valor de la vivienda',
  'pkn.sce.home.storySerial': 'Una vivienda de {price} con {equity} de capital propio supone un préstamo de {loan} y un préstamo de amortización constante con una cuota de unos {monthly} al mes. El capital propio queda inmovilizado, pero la vivienda va generando patrimonio con el tiempo.',
  'pkn.sce.home.storyAnnuity': 'Una vivienda de {price} con {equity} de capital propio supone un préstamo de {loan} y un préstamo de cuota fija con una cuota de unos {monthly} al mes. El capital propio queda inmovilizado, pero la vivienda va generando patrimonio con el tiempo.',
  'pkn.sce.car.label': 'Comprar un coche',
  'pkn.sce.car.price': 'Precio del coche',
  'pkn.sce.car.depreciation': 'Depreciación a 5 años',
  'pkn.sce.car.story': 'Un coche de {price} con {equity} de capital propio supone un préstamo de {loan} y una cuota de unos {monthly} al mes. Un coche pierde valor, así que el patrimonio neto baja durante los primeros años.',
  'pkn.sce.retire.label': 'Jubilarse antes',
  'pkn.sce.retire.field': 'Edad de jubilación deseada',
  'pkn.sce.retire.statAge': 'Edad deseada',
  'pkn.sce.retire.statEarlier': 'Años antes',
  'pkn.sce.retire.statNeeded': 'Extra necesario',
  'pkn.sce.retire.storyNone': 'Con una edad de jubilación de {age} años sigues el plan actual: no hace falta ahorrar más.',
  'pkn.sce.retire.story': 'Si quieres jubilarte a los {age} años, {years} años antes que en el plan actual, tendrás que cubrir unos {gap} de necesidades de jubilación adicionales. Eso equivale a aproximadamente {required} de ahorro extra al mes a partir de ahora.',
  'pkn.sce.debt.label': 'Amortizar deuda',
  'pkn.sce.debt.today': 'Deuda actual',
  'pkn.sce.debt.extraField': 'Amortización extra al mes',
  'pkn.sce.debt.statExtra': 'Amortización extra',
  'pkn.sce.debt.statEarlier': 'Libre de deuda antes',
  'pkn.sce.yearsDecimal': '{years} años',
  'pkn.sce.debt.statInterest': 'Intereses ahorrados',
  'pkn.sce.debt.storyNone': 'Introduce tu deuda para ver cuánto antes te liberas de ella con amortizaciones extra.',
  'pkn.sce.debt.storyNoExtra': 'Sin amortización extra, la deuda sigue el plan de amortización actual.',
  'pkn.sce.debt.story': 'Si pagas {extra} extra de deuda cada mes, te libras de ella unos {years} años antes y ahorras aproximadamente {interest} en intereses.',
  'pkn.sce.preset.child.name': 'Hijo',
  'pkn.sce.preset.child.note': 'Equipamiento, guardería y mayores gastos',
  'pkn.sce.preset.wedding.name': 'Boda',
  'pkn.sce.preset.wedding.note': 'Gasto puntual de la celebración',
  'pkn.sce.preset.leave.name': 'Excedencia prolongada',
  'pkn.sce.preset.leave.note': 'Ingresos reducidos durante un periodo',
  'pkn.sce.preset.sabbatical.name': 'Año sabático',
  'pkn.sce.preset.sabbatical.note': 'Un año sin ingresos salariales',
  'pkn.sce.preset.partTime.name': 'Reducir jornada',
  'pkn.sce.preset.partTime.note': 'Ingresos permanentemente menores',
  'pkn.sce.preset.raise.name': 'Aumento de sueldo',
  'pkn.sce.preset.raise.note': 'Más para ahorrar cada mes',
  'pkn.sce.preset.renovation.name': 'Reforma',
  'pkn.sce.preset.renovation.note': 'Gasto puntual importante en la vivienda',
  'pkn.sce.preset.inheritance.name': 'Herencia o bonificación',
  'pkn.sce.preset.inheritance.note': 'Importe puntual recibido (coste negativo)',
  'pkn.sce.planInfo': 'Este es el punto de partida del que parten todos los escenarios. Si cambias el plan, la proyección, los objetivos y el panorama de jubilación se actualizan automáticamente y se guardan para el año seleccionado.',
  'pkn.sce.hintMonthlySave': 'Importe fijo que apartas cada mes',
  'pkn.sce.hintExtraDebt': 'Además de las amortizaciones ordinarias; también aumenta el patrimonio neto',
  'pkn.sce.hintTarget': 'El objetivo con el que medimos la proyección',
  'pkn.sce.hintReturn': 'Una media prudente a largo plazo: lo habitual es un 3–4 %',
  'pkn.sce.phAge': 'Tu edad',
  'pkn.sce.phDesiredAge': 'Edad deseada',
  'pkn.sce.pensionSpend': 'Gasto mensual esperado como jubilado',
  'pkn.sce.pensionSpendHint': 'Solo se usa en la proyección de jubilación.',
  'pkn.sce.newEvent': 'Nuevo evento vital',
  'pkn.sce.editEvent': 'Editar evento vital',
  'pkn.sce.add': 'Añadir',
  'pkn.sce.saveChanges': 'Guardar cambios',
  'pkn.sce.hintOneOff': 'Número negativo = ingreso puntual',
  'pkn.sce.hintMonthlyEffect': 'Negativo = mayor gasto / menores ingresos',
  'pkn.sce.hintDuration': '0 = cambio permanente',
  'pkn.sce.newGoalDefault': 'Nuevo objetivo',
  'pkn.sce.leverFixed': 'Ahorro mensual fijo',
  'pkn.sce.leverSetUp': 'Configurar un ahorro fijo',
  'pkn.sce.goalPasses': '{name} supera {amount}',
  'pkn.sce.newGoal': 'Nuevo objetivo',
  'pkn.sce.editGoal': 'Editar objetivo',
  'pkn.sce.createGoal': 'Crear objetivo',
  'pkn.sce.linkSavings': 'Vincular a una cuenta de ahorro',
  'pkn.sce.linkSavingsHint': 'Cuando se vincula una cuenta, el importe ahorrado se obtiene automáticamente del último saldo registrado.',
  'pkn.sce.noAccount': 'Ninguna cuenta',
  'pkn.main.tab.idag': 'Hoy',
  'pkn.main.tab.oversikt': 'Resumen',
  'pkn.main.tab.forbruk': 'Gastos',
  'pkn.main.tab.familie': 'Familia',
  'pkn.main.tab.fremtid': 'Futuro',
  'pkn.main.tab.reports': 'Informes',
  'pkn.main.tab.assets': 'Activos',
  'pkn.main.tab.gjeld': 'Deuda',
  'pkn.main.tab.skatt': 'Impuestos',
  'pkn.main.tab.import': 'Importar',
  'pkn.main.tab.transaksjoner': 'Transacciones',
  'pkn.main.asset': 'Activo',
  'pkn.main.debt': 'Deuda',
  'pkn.main.netWealth': 'Patrimonio neto',
  'pkn.main.in': 'Entradas',
  'pkn.main.out': 'Salidas',
  'pkn.main.loanPayments': 'Pagos de préstamos',
  'pkn.main.savingsInvesting': 'Ahorro/inversión',
  'pkn.main.heroIntro': 'SuperPlumma te ayuda a ti y a tu familia con el ahorro, el presupuesto, los préstamos, la jubilación y la declaración de impuestos, como un asesor financiero privado disponible las 24 horas.',
  'pkn.main.loadFailed': 'No se pudieron obtener las finanzas personales.',
  'pkn.main.actionUnavailable': 'La acción todavía no está disponible.',
  'pkn.main.actionFailed': 'La acción ha fallado.',
  'pkn.main.taskUpdated': 'La tarea se ha actualizado.',
  'pkn.main.choiceSaved': 'La elección se ha guardado y se usará en futuras sugerencias.',
  'pkn.main.moveUnavailable': 'El cambio de categoría todavía no está disponible.',
  'pkn.main.movedRuleSaved': 'Transacciones movidas y regla guardada.',
  'pkn.main.moved': 'Transacciones movidas.',
  'pkn.main.moveFailed': 'No se pudieron mover las transacciones.',
  'pkn.main.importUnavailable': 'La importación de finanzas personales todavía no está disponible.',
  'pkn.main.uploadedShowingYear': 'El extracto se ha subido. Mostrando {year}.',
  'pkn.main.uploaded': 'El extracto se ha subido.',
  'pkn.main.uploadFailed': 'La subida ha fallado.',
  'pkn.main.recatUnavailable': 'La recategorización todavía no está disponible.',
  'pkn.main.recatAlreadyRight': '{count} ya eran correctas',
  'pkn.main.recatManual': '{count} se movieron manualmente y no se tocaron',
  'pkn.main.recatStillOther': '{count} siguen en «Otros»',
  'pkn.main.recatDone': '{done} de {total} transacciones recibieron una nueva categoría',
  'pkn.main.recatFailed': 'La recategorización ha fallado.',
  'pkn.main.bufferSaved': 'El objetivo del colchón se ha guardado.',
  'pkn.main.budgetSaved': 'El presupuesto se ha guardado.',
  'pkn.main.householdSaved': 'El hogar se ha guardado.',
  'pkn.main.planSaved': 'El plan se ha guardado.',
  'pkn.main.assetSaved': 'Activo guardado.',
  'pkn.main.assetDeleted': 'Activo eliminado.',
  'pkn.main.loanSaved': 'El préstamo se ha guardado.',
  'pkn.main.loanDeleted': 'El préstamo se ha eliminado.',
  'pkn.main.taxChecklistSaved': 'La lista de comprobación fiscal se ha guardado.',
  'pkn.main.accountSaved': 'Cuenta guardada.',
  'pkn.main.accountDeleted': 'Cuenta eliminada junto con sus extractos.',
  'pkn.main.statementLinked': 'El extracto se ha vinculado a una cuenta.',
  'pkn.main.statementDeleted': 'El extracto se ha eliminado.',
  'pkn.main.assistantUnavailable': 'El asistente de finanzas personales no está disponible.',
  'pkn.main.personalFinanceName': 'Finanzas personales',
  'pkn.fut.noEvents': 'Todavía no hay eventos vitales. Añade uno (por ejemplo, un hijo, la compra de una vivienda o un año sabático) y te mostraré cómo afecta a tu patrimonio y a tus objetivos con el tiempo.',
});
